// This is the entry point for the home component
import React, { FC, useCallback, useContext } from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Styling
import injectSheet from 'react-jss';

// Actions

// Components
import { FilterRadioHidden } from 'Components/FilterRadioHidden';
import { FilterSlider } from 'Components/FilterSlider';

import { ProductAnalyticsContext } from 'Context/ProductAnalytics';

import { areEqualObjects } from 'Utils/areEqual';
import { setSelectionOrValue } from './actions/age.actions';
import styleSheet from './styles';

interface Props {
  classes: any;
}

const Age: FC<Props> = (props: Props) => {
  // Will be needed for future use.
  const age = useSelector(
    (selectors: any) => selectors.filter.demographics.age,
    areEqualObjects
  );
  const dispatch = useDispatch();

  const {
    actions: { filterTrack },
  } = useContext(ProductAnalyticsContext);

  const { classes } = props;

  const callback = (event: any) => {
    const { id, value } = event.target;

    // Combined Analytics Event
    filterTrack({
      filterCategory: 'Demographics',
      filterName: 'Age',
      filterValue: value,
      addToStore: value === 'Any', // we only want to add this to the store if the value is Any.  We will track the slider values in rangeSliderChange
    });

    setSelectionOrValue(dispatch, age, value, id);
  };

  /*
  If this event is called, then I know what hte value are.
  */
  const rangeSliderChange = (values: number[]) => {
    // Combined Analytics Event
    const [lower, upper] = values;
    filterTrack({
      filterCategory: 'Demographics',
      filterName: 'Age.SpecificAgeRange',
      filterValue: `${lower} - ${upper}${upper === 40 ? '+' : ''}`, // Add the plus sign if it's at the maximum,
      addToStore: true,
    });

    setSelectionOrValue(dispatch, age, values, 'value');
  };

  return (
    <div className={classes.container}>
      <FilterRadioHidden
        label="Any"
        value="Any"
        selected={age.selection === 'Any'}
        identifier="selectionAge"
        onClick={useCallback(callback, [age])}
      />
      <FilterRadioHidden
        label="Specific Age Range"
        value="Specific Age Range"
        selected={age.selection === 'Specific Age Range'}
        identifier="selectionAge"
        onClick={useCallback(callback, [age])}
        overrideStyles={{
          marginLeft: '27px',
        }}
      >
        <FilterSlider
          defaultValues={{
            handleOne: age.value.lower,
            handleTwo: age.value.upper,
          }}
          range={{ lowerBound: 13, upperBound: 40 }}
          step={1}
          onSlideEnd={useCallback(rangeSliderChange, [age])}
          upperBoundMaxLabel=" +"
          ariaLabel="Select Age Range"
        />
      </FilterRadioHidden>
    </div>
  );
};

export default injectSheet(styleSheet)(Age);
